import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { boxesQuery } from 'networking/mindfeed/queries/boxes';
import { Box } from 'models/Box';
import { useActiveSpace } from 'xstate/hooks/useActiveSpace';
import { SpaceId } from 'models/Space';

type QueryKeyType = [QueryKey.BOXES, SpaceId?];

type Options = Omit<
  UseQueryOptions<Box[], unknown, Box[], QueryKeyType>,
  'queryKey' | 'queryFn'
>;

type Params = {
  options?: Options;
};

export default function useBoxes({ options = {} }: Params = {}) {
  const { selectedSpaceId } = useActiveSpace();

  // Same definition as the space machine uses, so a list it already loaded
  // is read from the cache here. With no space selected the query is
  // defined but doesn't run (see boxesQuery).
  const query = useQuery({
    ...boxesQuery(selectedSpaceId),
    // Keep previous data while new data is being fetched
    // This prevents unnecessary loading states and improves UX
    placeholderData: (previousData) => previousData,
    ...options,
  });

  const canRun = !!selectedSpaceId && (options?.enabled ?? true);

  return {
    ...query,
    isLoading: !canRun || query.isPending,
  };
}
